import type { SubjectCode } from '../../../types'
import { SUBJECT_COLORS, SUBJECT_NAMES } from '../../../constants/colors'

interface SubjectTabsProps {
  selectedSubject: SubjectCode
  onSubjectChange: (subject: SubjectCode) => void
}

const subjects: SubjectCode[] = ['NEET_UG_PHY', 'NEET_UG_CHEM', 'NEET_UG_BIO']

export default function SubjectTabs({ selectedSubject, onSubjectChange }: SubjectTabsProps) {
  return (
    <div className="flex gap-1 bg-gray-100 rounded-lg p-1">
      {subjects.map((subject) => {
        const isSelected = selectedSubject === subject
        return (
          <button
            key={subject}
            onClick={() => onSubjectChange(subject)}
            className={`flex-1 px-4 py-2 text-sm font-medium rounded-md transition-all ${
              isSelected
                ? 'bg-white shadow-sm'
                : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
            }`}
            style={{
              color: isSelected ? SUBJECT_COLORS[subject] : undefined,
            }}
          >
            {SUBJECT_NAMES[subject]}
          </button>
        )
      })}
    </div>
  )
}
